import React, { useEffect } from "react";
import SEO from "../components/SEO";

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <SEO
        title="Terms & Conditions"
        description="Read the terms and conditions for using Trademark Facility' services."
        path="/terms"
      />
      {/* Hero */}
      <section className="relative bg-primary text-white py-12 md:py-16 overflow-hidden">
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage:
              "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
            backgroundSize: "40px 40px",
          }}
        />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h1 className="font-heading text-3xl md:text-5xl font-extrabold mb-3 tracking-tight">
            Terms & Conditions
          </h1>
          <p className="text-gray-400 text-sm sm:text-base">
            Please read these terms carefully before using our services.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-10 md:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate max-w-none">
          <p className="text-slate-600 leading-relaxed mb-6 text-sm sm:text-base">
            By accessing the Trademark Facility website (referred to as the
            "Site"), you acknowledge and accept the terms and conditions
            outlined herein, forming an agreement between you and
            info@trademarkfacility.com (referred to as "we," "us," or "our").
            This agreement also incorporates our Privacy Policy as if fully
            stated here. If you do not agree with these terms, please refrain
            from using the Site. We offer general information related to
            trademarks and provide a platform where you can prepare and file
            trademarks.
          </p>

          <p className="text-slate-800 font-bold mb-6 bg-slate-50 p-4 rounded-lg border-l-4 border-lime">
            THIS AGREEMENT INCLUDES A MANDATORY ARBITRATION CLAUSE GOVERNED BY
            THE FEDERAL ARBITRATION ACT, AND A WAIVER OF CLASS ACTIONS.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Conditions for Use of the Site
          </h2>
          <p className="text-slate-600 mb-4">
            Your access to and use of the Site is contingent upon your
            acceptance and adherence to these terms. By using the Site, you
            agree that you:
          </p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6">
            <li>Will comply with these Terms of Service;</li>
            <li>Are 18 years of age or older;</li>
            <li>
              Will not use the Site in any way that violates U.S. laws,
              including its export and re-export regulations;
            </li>
            <li>
              Will not copy or distribute any content from the Site without our
              prior written consent;
            </li>
            <li>
              Will provide accurate details when registering, submitting
              content, or interacting with the Site;
            </li>
            <li>
              Will not permit others to use the Site under your user
              credentials;
            </li>
            <li>
              Are fully responsible for all activity under your account and user
              credentials;
            </li>
            <li>
              Will not use the Site for commercial purposes other than those
              expressly stated;
            </li>
            <li>
              Will not use the Site to collect personal information about others
              or solicit users or advertisers;
            </li>
            <li>
              Are solely responsible for any content you submit to the Site,
              ensuring you have the rights or licenses to do so, and will not
              upload any materials infringing on others' copyrights or
              proprietary rights;
            </li>
            <li>
              Grant us and other users a non-exclusive license to use, display,
              reproduce, distribute, or create derivative works from your
              submitted materials; and
            </li>
            <li>
              Agree that we may remove any of your content and suspend or
              terminate your account, with or without prior notice.
            </li>
          </ul>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Your Content
          </h2>
          <p className="text-slate-600 mb-4">
            We reserve the right to publish any content you provide (referred to
            as "User-Generated Content" or "UGC"). You agree not to upload or
            use any UGC that:
          </p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6">
            <li>
              Violates the intellectual property rights of others, including
              copyright, trademarks, or trade secrets;
            </li>
            <li>
              Infringes on privacy or publicity rights of any third party;
            </li>
            <li>
              Is unlawful, inaccurate, defamatory, discriminatory, obscene, or
              harassing;
            </li>
            <li>Encourages criminal activity or civil liability;</li>
            <li>Is deemed inappropriate by us, in our sole discretion; or</li>
            <li>Could harm our company, affiliates, or partners.</li>
          </ul>
          <p className="text-slate-600 mb-6">
            We are not obligated to remove UGC violating these terms, but we
            reserve the right to do so at our discretion, and may take further
            action such as account termination. We are not liable for any harm
            caused by UGC.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Your Behavior
          </h2>
          <p className="text-slate-600 mb-4">
            By using the Site, you agree not to:
          </p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6">
            <li>Engage in or promote illegal activities;</li>
            <li>
              Attempt to reverse engineer or disrupt the Site's functionality;
            </li>
            <li>Attempt to access restricted areas of the Site;</li>
            <li>Use the Site for unsolicited email campaigns or spam;</li>
            <li>
              Use automated tools to scrape or collect data from the Site;
            </li>
            <li>Interfere with the proper functioning of the Site;</li>
            <li>Impersonate another user.</li>
          </ul>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Links to Third-Party Sites
          </h2>
          <p className="text-slate-600 mb-6">
            Our Site may contain links to third-party websites not controlled by
            us. We assume no responsibility for the content or practices of
            these external sites. Linking to these sites does not imply
            endorsement by us.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Termination
          </h2>
          <p className="text-slate-600 mb-6">
            We reserve the right to modify or discontinue the Site or any
            services provided without prior notice. Additionally, we may
            terminate this agreement for any reason, with or without notice. If
            we terminate your access due to violations of these terms, you will
            immediately lose access to the Site. The clauses related to
            warranties, liabilities, indemnity, dispute resolution, and your
            content will survive the termination of this agreement.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Displaying Data and Search Features
          </h2>
          <p className="text-slate-600 mb-6">
            We may use official government records and display them on the Site.
            While we strive to ensure accuracy, we do not guarantee that the
            information is up-to-date or error-free.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Calendar Reminders
          </h2>
          <p className="text-slate-600 mb-6">
            We may offer reminders about specific trademark deadlines as part of
            our services. These reminders are for general informational purposes
            and may not apply to your unique circumstances. We recommend
            consulting with a licensed attorney regarding deadlines specific to
            your situation.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Credit Card Information
          </h2>
          <p className="text-slate-600 mb-6">
            We may store your credit card details only for the purpose of paying
            the filing fees associated with your order, provided you approve the
            application and are aware of the costs involved.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Search Services
          </h2>
          <p className="text-slate-600 mb-6">
            If you use our search services, we employ reasonable methods to
            identify potential matches to the trademarks you wish to use.
            However, we cannot guarantee that your trademark will be approved by
            the USPTO or that it will not face challenges, even with our search
            services. There are cases where automated searches may not identify
            conflicts that could result in rejection by the USPTO. Similarly,
            for common law mark searches, while we use commercially reasonable
            methods to find potential matches, we cannot guarantee that all
            common law claims will be identified.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Trademark Search Scope
          </h2>
          <p className="text-slate-600 mb-6">
            Our Trademark Facility federal search reviews the USPTO database and
            includes direct matches, phonetic similarities, or visual design
            similarities. Our Trademark Facility federal, state, and common law
            search extends to all 50 states, a business registry, and domain
            name databases, including matches in phonetics, design, or
            translation. Our Trademark Facility global search includes the USPTO
            database, state databases, business registries, domain name
            databases, the WIPO database, and the European Community database,
            focusing on direct matches, phonetic similarities, or visual design
            likenesses.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Trademark Monitoring Services
          </h2>
          <p className="text-slate-600 mb-6">
            Our trademark monitoring service reviews the filing of new
            applications that are direct matches, phonetically similar, similar
            in terms of translation, or appearance by way of design to your
            marks as published in the Official Gazette of the USPTO and
            Trademark Facility.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Subscription and Auto-Renewals
          </h2>
          <p className="text-slate-600 mb-4">
            If you signed up for one or more subscription services through the
            Website, these additional terms apply. Your license to the Services
            is valid during the period your subscription remains in good
            standing and there are no outstanding subscription payments
            (hereinafter "Subscription Term"). To keep your Subscription Term
            valid and in force, you must pay all charges to your account
            relating to your subscriptions, including applicable taxes and fees.
            Unless otherwise provided, your Subscription Term is on an automatic
            renewal and you will be required to pay, through the credit card
            provided by you, for the next applicable Subscription Term at the
            beginning of the Subscription Term period. These charges are applied
            regardless of whether you continue to use the Services during the
            Subscription Term.
          </p>
          <p className="text-slate-800 font-bold mb-4 bg-slate-50 p-4 rounded-lg border-l-4 border-lime">
            YOU ARE RESPONSIBLE FOR SUBSCRIPTION FEES UNTIL YOU CANCEL YOUR
            SUBSCRIPTION OR IT IS OTHERWISE TERMINATED.
          </p>
          <p className="text-slate-600 mb-4">
            If your Subscription Term is month to month and your purchase date
            is on the 29th through 31st day of any month, your renewal date will
            fall on the last day of the month for any succeeding months with
            fewer days. Unless otherwise provided, the renewal period will be
            the same as the price you originally paid.
          </p>
          <p className="text-slate-600 mb-4">
            We may offer promotional trial memberships. Although the promotional
            trial membership may be advertised as free promotional memberships,
            you authorize us to charge your credit card $1 to confirm the source
            of the payment. AT THE END OF A TRIAL OR PROMOTIONAL MEMBERSHIP,
            UNLESS OTHERWISE STATED IN THE OFFER OR YOU CANCEL, YOUR
            SUBSCRIPTION WILL RENEW AUTOMATICALLY AND YOUR CREDIT CARD WILL BE
            CHARGED TO BEGIN YOUR INITIAL SUBSCRIPTION TERM.
          </p>
          <p className="text-slate-600 mb-4">
            We may discontinue offering subscriptions and will cease charging
            you accordingly. We may also terminate your Subscription in our sole
            discretion subject to your right to a pro-rated refund of fees.
          </p>
          <p className="text-slate-600 mb-6">
            To cancel your subscription, contact us at
            info@trademarkfacility.com. After you have cancelled, your
            subscription and account will remain active through the end of the
            then current Subscription Term.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Disclaimers of Warranty and Limitations of Liability
          </h2>
          <p className="text-slate-600 mb-4">
            We provide the Website and the related services "as is", "where is",
            and "as available." We make no express and/or implied warranties or
            guarantees about the Website, the goods and services described
            thereon or the Advertisers.
          </p>
          <p className="text-slate-800 font-bold mb-6 bg-slate-50 p-4 rounded-lg border-l-4 border-lime text-sm">
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE AND OUR OFFICERS,
            DIRECTORS, AGENTS, VENDORS, AND THE MERCHANTS WHO ADVERTISE WITH US
            DISCLAIM ANY AND ALL EXPRESS OR IMPLIED WARRANTIES THAT THE WEBSITE
            AND SERVICES ARE MERCHANTABLE, OF SATISFACTORY QUALITY, ACCURATE,
            TIMELY OR FIT FOR A PARTICULAR PURPOSE OR NEED. WE IN NO WAY
            GUARANTEE THAT WE WILL MEET YOUR REQUIREMENTS, IS ERROR-FREE,
            ACCURATE, RELIABLE, WITHOUT INTERRUPTION OR AVAILABLE AT ALL TIMES.
            YOUR SOLE AND EXCLUSIVE REMEDY FOR ANY DISPUTE OR CLAIM WITH US IS
            TO CEASE USE OF THE WEBSITE.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Indemnity
          </h2>
          <p className="text-slate-600 mb-6">
            You agree to defend, indemnify and hold harmless us, our officers,
            directors, representatives, employees and agents and all of our
            parent companies, affiliates, related companies and their officers,
            directors, representatives, employees and agents from and against
            any and all claims, damages, obligations, losses, liabilities, costs
            or debt, and expenses (including but not limited to reasonable
            attorney's fees) arising from: (i) your violation of any term of
            these Terms of Service; (ii) your violation of any third party
            right, including without limitation any copyright, property, privacy
            right, or any and all intangible or intellectual property rights; or
            (iii) any claim that any of your UGC causes damage to a third party.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Dispute Resolution
          </h2>
          <p className="text-slate-600 mb-6">
            For the purposes of this Section, references to "Trademark
            Facility," "you," and "us" include our respective subsidiaries,
            affiliates, agents, employees, business partners, predecessors in
            interest, successors, and assigns, as well as all authorized or
            unauthorized users or beneficiaries of services or products under
            these Terms or any prior agreements between us. Any Dispute shall be
            FINALLY and EXCLUSIVELY resolved by binding individual arbitration
            conducted by the American Arbitration Association ("AAA") under its
            Consumer Arbitration Rules.
          </p>

          <p className="text-slate-800 font-bold mb-6 bg-slate-50 p-4 rounded-lg border-l-4 border-lime text-sm">
            NO CLASS ACTION, OR OTHER REPRESENTATIVE ACTION OR PRIVATE ATTORNEY
            GENERAL ACTION OR JOINDER OR CONSOLIDATION OF ANY CLAIM WITH A CLAIM
            OF ANOTHER PERSON OR CLASS OF CLAIMANTS SHALL BE ALLOWABLE.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Right to Opt-Out
          </h2>
          <p className="text-slate-600 mb-6">
            You may opt-out of arbitration by notifying us of your decision to
            reject the arbitration clause in writing. You must notify us in
            writing within 30 days of accepting this Agreement. Failure to do so
            will make this Agreement binding on you.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Copyright Notice
          </h2>
          <p className="text-slate-600 mb-6">
            If you believe your copyright has been violated, please send a
            notification in accordance with the Digital Millennium Copyright Act
            (17 U.S.C. § 512(c)(3)) to info@trademarkfacility.com with the
            subject line: "Copyright Notice."
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Authorization
          </h2>
          <p className="text-slate-600 mb-6">
            By submitting an order, you authorize us to receive correspondence
            from the USPTO related to your trademarks alongside you. While you
            can revoke this at any time, including us in communications helps us
            assist you better and may be necessary for services such as
            monitoring and scheduling.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Refund Policy
          </h2>
          <p className="text-slate-600 mb-6">
            All packages include attorney-conducted searches and are
            non-refundable. Once a search and clearance report is issued,
            payment will be automatically processed within 24-48 hours if we do
            not receive a response from you via email or phone. The payment will
            be transferred to the USPTO (United States Patent and Trademark
            Office) through the attorney.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Entire Agreement
          </h2>
          <p className="text-slate-600 mb-6">
            This Agreement, together with the Privacy Policy, represents the
            complete and exclusive agreement between the parties regarding the
            subject matter herein. No waiver of any breach or default by either
            party constitutes a waiver of any prior or subsequent breach or
            default.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Modifications to the Agreement
          </h2>
          <p className="text-slate-600 mb-6">
            We retain the right to modify or discontinue any of these terms
            and/or the Privacy Policy at any time, as we deem necessary. Changes
            may include the introduction of new fees or charges. Continued use
            of the Website after such notice shall be deemed as acceptance of
            the changes.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">
            Miscellaneous
          </h2>
          <p className="text-slate-600 mb-6">
            We reserve the right to limit the sale of our products or services
            to any individual, location, or jurisdiction, at our discretion, on
            a case-by-case basis. Product descriptions and pricing may change
            without notice, at our sole discretion. We also reserve the right to
            discontinue any product at any time. Offers made on this website are
            void where prohibited. If any part of this Agreement is found
            invalid by a court of competent jurisdiction, the remainder of the
            Agreement will remain valid and enforceable. You may not assign your
            rights or obligations under this Agreement to any third party
            without our prior written consent, and any unauthorized assignment
            will be invalid.
          </p>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
